/* istanbul ignore file */
import React from "react";
import ReactDOM from "react-dom";
import App from "@data-force/app";
import {Route} from "react-router";
import {Modal} from "antd";
import {actionWatcher as mainSagaActionWatcher} from "./store/sagas/main";
import {actionWatcher as addTranslationSagaActionWatcher} from "./store/sagas/antdTranslation";
import {actionWatcher as commonActionWatcher} from "./store/sagas/common";
import {actionWatcher as taskActionWatcher} from "./store/sagas/task";
import MainPage from "./pages/MainPage/MainPage";
import antdTranslationReducer from "./store/reducers/antdTranslation";
import uploadFilesReducer from "./store/reducers/uploadFiles";
import "./index.scss";
import projectReducer from "./store/reducers/project";
import jobReducer from "./store/reducers/job";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import layoutReducer from "./store/reducers/layout";
import ErrorPageUnauthorized from "./pages/ErrorPageUnauthorized/ErrorPageUnauthorized";

ReactDOM.render(
    <App
        sagasToFork={[
            mainSagaActionWatcher,
            addTranslationSagaActionWatcher,
            taskActionWatcher,
            commonActionWatcher,
        ]}
        reducers={{
            antdTranslation: antdTranslationReducer,
            project: projectReducer,
            job: jobReducer,
            uploadFiles: uploadFilesReducer,
            layout: layoutReducer,
        }}
        axiosErrors={{
            500: {
                dialog: Modal.error,
                customOkText: true,
            },
            502: {
                dialog: Modal.error,
            },
            503: {
                dialog: Modal.error,
            },
            412: {
                dialog: Modal.error,
            },
            415: {
                dialog: Modal.error,
            },
            429: {
                dialog: Modal.confirm,
                customOkText: true,
                customCancelText: true,
                dialogConfig: {
                    icon: "close-circle",
                    cancelButtonProps: {
                        type: "primary",
                    },
                },
            },
        }}
    >
        <Route
            path="/:idpId/:phase/:projectId/:jobId/:jobPhaseId?"
            component={MainPage}
        />
        <Route path="/unauthorized" component={ErrorPageUnauthorized}/>
        <Route render={() => <ErrorPage/>}/>

    </App>,
    document.getElementById("root"),
);
